// =============================================================================
// Copyright   : 2020 semantics GmbH
// Date        : $Date: 2020-05-19 02:19:46 +0200 (Tue, 19 May 2020) $
// Author      : Ulrich Mierendorff
// Worker      : $Author: u.mierendorff $
// Revision    : $Rev: 110590 $
// Purpose     : Database Administration and Debugging Parts
// =============================================================================

import {treeAspect, isRootDomainConfig, isDomainRecord} from 'uix/views/utils'

import {ACTIVITIES_MAX_RESULTS_DEFAULT, ACTIVITIES_MIN_DURATION_DEFAULT} from './constants'

export const database = {
  ...treeAspect,
  tabGroup: 'database',
  acl: 'g:debug',
  cfg: isRootDomainConfig,
  enabled: isDomainRecord,
  tabs: {
    cmd: {default: true, tabGroupDefault: true, parts: ['DatabaseCommand']},
    stats: {parts: ['DatabaseTableStats']},
    index: {parts: [{type: 'DatabaseIndexes', filters: ['getDatabaseIndexInfoJSON']}]},
    activities: {
      parts: [
        {
          type: 'DatabaseActivities',
          filters: [
            {
              type: 'getDBOperations',
              max: ACTIVITIES_MAX_RESULTS_DEFAULT,
              minDuration: ACTIVITIES_MIN_DURATION_DEFAULT,
            },
          ],
        },
      ],
    },
    schema: {parts: [{type: 'DatabaseSchema', filters: ['getDatabaseSchemaJSON']}]},
    backup: {parts: [{type: 'DatabaseBackup', filters: ['getDatabaseBackupInfoJSON']}]},
    updates: {parts: [{type: 'DatabaseUpdates', filters: ['getDatabaseInfo']}]},
  },
}
